export default __webpack_public_path__ + "img/b32ce9ed36b5ca2e730a54c6acd4ff8f.svg";